// extracted by mini-css-extract-plugin
module.exports = {"accordion":"Accordion_accordion__cs1F0","collapsed":"Accordion_collapsed__EBlI1","noDataFounded":"Accordion_noDataFounded__wO7OY"};